class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    const target = event.target;
    if (!target) return;

    // Tap dimmed / empty backdrop (or outside the modal) closes search
    if (
      target.classList.contains('modal-overlay') ||
      target.classList.contains('search-modal') ||
      (target.classList.contains('modal__content') && target.classList.contains('search-modal'))
    ) {
      this.close(false);
      return;
    }

    if (!this.contains(target)) this.close(false);
  }

  setSearchPanelTop() {
    const announcement = document.querySelector('.announcement-bar, .shopify-section-announcement-bar, #shopify-section-announcement-bar');
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper');

    let top = 0;
    if (header) {
      top = Math.round(header.getBoundingClientRect().bottom);
    } else if (announcement) {
      top = Math.round(announcement.getBoundingClientRect().bottom);
    }

    document.documentElement.style.setProperty('--search-panel-top', `${Math.max(0, top)}px`);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    // Defer so the opening tap does not immediately close
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);
    document.body.classList.add('overflow-hidden');

    if (this.classList.contains('header__search')) {
      this.setSearchPanelTop();
      document.body.classList.add('minnies-search-open');
      this._onSearchResize = () => this.setSearchPanelTop();
      window.addEventListener('resize', this._onSearchResize);
      window.addEventListener('scroll', this._onSearchResize, { passive: true });

      const overlay = this.querySelector('.modal-overlay');
      if (overlay) {
        this._onOverlayClick = this._onOverlayClick || (() => this.close(false));
        overlay.addEventListener('click', this._onOverlayClick);
      }
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('minnies-search-open');

    if (this._onOverlayClick) {
      const overlay = this.querySelector('.modal-overlay');
      if (overlay) overlay.removeEventListener('click', this._onOverlayClick);
    }

    if (this._onSearchResize) {
      window.removeEventListener('resize', this._onSearchResize);
      window.removeEventListener('scroll', this._onSearchResize);
      this._onSearchResize = null;
    }

    /* Clear stuck menu/search overlay leftovers */
    document.body.classList.remove('minnies-menu-open');
    const drawer = document.getElementById('menu-drawer');
    if (drawer) drawer.classList.remove('is-open');
  }
}

customElements.define('details-modal', DetailsModal);
